module.exports = __webpack_public_path__ + "img/exposer.a061920f.webp";